import { render, staticRenderFns } from "./DeviceMakes.vue?vue&type=template&id=13f3e8d4&"
import script from "./DeviceMakes.vue?vue&type=script&lang=js&"
export * from "./DeviceMakes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports